import React from "react";
import { TEAL } from "./constants";
import { IconSparkle, IconVisionBoard, IconMindMap } from "../../lib/Icons/WhiteboardIcons";

export const CREATIVE_STARTS = [
  { id: "help-me-start", label: "Help me start",    Icon: IconSparkle,     hint: "Lumen asks what you're working on" },
  { id: "moodboard",     label: "Create a moodboard", Icon: IconVisionBoard, hint: "Drops a moodboard layout to fill" },
  { id: "map-idea",      label: "Map out an idea",   Icon: IconMindMap,     hint: "Drops a mind map starter" },
];

export default function CreativeStarts({ onStart }) {
  return (
    <div className="flex items-center justify-center gap-[10px] py-[10px] flex-wrap">
      {CREATIVE_STARTS.map(({ id, label, Icon, hint }) => (
        <button
          key={id}
          type="button"
          title={hint}
          onClick={() => onStart(id)}
          className="flex items-center gap-[8px] px-[16px] py-[9px] rounded-[12px] font-['DM_Sans'] text-[12.5px] font-semibold cursor-pointer transition-all duration-120 border"
          style={{
            background: "rgba(253,251,247,0.8)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            borderColor: "rgba(0,0,0,0.06)",
            color: "#334155",
            boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = TEAL;
            e.currentTarget.style.borderColor = "rgba(77,184,181,0.45)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#334155";
            e.currentTarget.style.borderColor = "rgba(0,0,0,0.06)";
          }}
        >
          <span style={{ color: TEAL }}><Icon size={17} /></span>
          {label}
        </button>
      ))}
    </div>
  );
}
